import { css } from 'styled-components';

export default css`
  overflow: hidden;
  .order-tracking-line {
    background-color: ${props => props.theme.orderLineBackground};
    color: ${props => props.theme.orderLineForeground};
  }
`;
